import React from 'react';
import './DonationStatsBar.css';

interface DonationStatsBarProps {
  /** 累计捐赠金额 */
  totalAmount: number;
  /** 已支持项目数量 */
  projectCount: number;
  /** 是否可点击（用于跳转） */
  onClickTotalAmount?: () => void;
  /** 是否可点击（用于跳转） */
  onClickProjectCount?: () => void;
}

/**
 * 捐赠统计栏组件
 * 显示累计捐赠金额和已支持项目数量
 */
export const DonationStatsBar: React.FC<DonationStatsBarProps> = ({
  totalAmount,
  projectCount,
  onClickTotalAmount,
  onClickProjectCount,
}) => {
  return (
    <div className="donation-stats-bar">
      <div
        className="donation-stat-item"
        onClick={onClickTotalAmount}
        style={{ cursor: onClickTotalAmount ? 'pointer' : 'default' }}
      >
        <div className="donation-stat-value">{totalAmount.toFixed(2)}</div>
        <div className="donation-stat-label">累计捐赠</div>
      </div>
      <div
        className="donation-stat-item"
        onClick={onClickProjectCount}
        style={{ cursor: onClickProjectCount ? 'pointer' : 'default' }}
      >
        <div className="donation-stat-value">{projectCount}</div>
        <div className="donation-stat-label">已支持项目</div>
      </div>
    </div>
  );
};

